import { jsPDF } from "jspdf";

export function generatePlotBrochure(plots) {
  const doc = new jsPDF();
  const orange = [234, 88, 12];
  const dark = [15, 23, 42];
  const gray = [100, 116, 139];

  // Header
  doc.setFillColor(...orange);
  doc.rect(0, 0, 210, 45, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.setTextColor(255, 255, 255);
  doc.text("VSINDLPARK.COM — VS AGRO INFRA ENTERPRISES", 15, 22);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text("Industrial Plots at IIE Sigaddi, SIIDCUL Kotdwar, Uttarakhand", 15, 32);
  doc.setFontSize(9);
  doc.text("Phone: +91-9258959058 | Email: amritinfotech9@gmail.com", 15, 40);

  // Subtitle
  let y = 55;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(...dark);
  doc.text("Plot Brochure & Price List", 15, y);
  y += 10;
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...gray);
  doc.text("SIDA Approved | 90-Year Leasehold | Adjacent to SIIDCUL IIE Sigaddi", 15, y);
  y += 12;

  // Table header
  doc.setFillColor(...dark);
  doc.rect(15, y, 180, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  const cols = [
    { label: "Plot Size (Sq.Mtr)", x: 18 },
    { label: "Rate / Sq.Mtr", x: 60 },
    { label: "Total Value", x: 100 },
    { label: "Status", x: 145 },
  ];
  cols.forEach((c) => doc.text(c.label, c.x, y + 7));
  y += 14;

  // Table rows
  doc.setFont("helvetica", "normal");
  const sortedPlots = [...plots].sort((a, b) => a.size - b.size);
  sortedPlots.forEach((plot, i) => {
    if (y > 260) {
      doc.addPage();
      y = 20;
    }
    if (i % 2 === 0) {
      doc.setFillColor(248, 250, 252);
      doc.rect(15, y - 4, 180, 10, "F");
    }
    doc.setFontSize(9);
    doc.setTextColor(...dark);
    doc.text(`${plot.size.toLocaleString("en-IN")} Sq.Mtr`, 18, y + 2);
    doc.setTextColor(...orange);
    doc.text(`Rs. ${plot.price_per_sqmtr?.toLocaleString("en-IN")}`, 60, y + 2);
    doc.setTextColor(...dark);
    const total = plot.total_price || plot.size * (plot.price_per_sqmtr || 0);
    doc.text(formatIndianRupee(total), 100, y + 2);
    const statusColor = plot.status === "available" ? [22, 163, 74] : plot.status === "reserved" ? [217, 119, 6] : [100, 116, 139];
    doc.setTextColor(...statusColor);
    doc.text(plot.status.charAt(0).toUpperCase() + plot.status.slice(1), 145, y + 2);
    y += 10;
  });

  // Payment Policy
  y += 10;
  if (y > 230) { doc.addPage(); y = 20; }
  doc.setFillColor(...orange);
  doc.rect(15, y, 180, 8, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("PAYMENT POLICY", 18, y + 6);
  y += 14;

  doc.setTextColor(...dark);
  doc.setFontSize(9);
  const policies = [
    "10% — Booking amount at the time of reservation",
    "15% — Within 30 days for allotment letter",
    "75% — Balance at lease deed execution (within 6 months)",
  ];
  policies.forEach((p) => {
    doc.setFont("helvetica", "bold");
    doc.text(p.split("—")[0], 18, y);
    doc.setFont("helvetica", "normal");
    doc.text("—" + p.split("—")[1], 30, y);
    y += 7;
  });

  // Key Features
  y += 8;
  if (y > 245) { doc.addPage(); y = 20; }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(...dark);
  doc.text("Key Features", 15, y);
  y += 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...gray);
  const features = [
    "SIDA Site Map Approval — 100% legally certified",
    "Power & Water Ready Infrastructure",
    "Adjacent to IIE SIIDCUL Sigaddi",
    "Spot Allotment Available",
    "All Govt. Incentives Eligible (15% Capital Subsidy, 5% Interest Subsidy)",
    "Bank Mortgage Eligible after 25% payment",
    "90-Year Leasehold Period",
  ];
  features.forEach((f) => {
    doc.text(`  •  ${f}`, 18, y);
    y += 6;
  });

  // Footer
  y += 8;
  doc.setDrawColor(...orange);
  doc.line(15, y, 195, y);
  y += 6;
  doc.setFontSize(8);
  doc.setTextColor(...gray);
  doc.text("VSINDLPARK.COM | VS Agro Infra Enterprises | IIE Sigaddi, SIIDCUL, Kotdwar, Pauri Garhwal, Uttarakhand - 246149", 15, y);
  y += 5;
  doc.text("Phone: +91-9258959058, +91-9557877290 | Email: amritinfotech9@gmail.com | Web: vsindlpark.in", 15, y);
  y += 5;
  doc.setFontSize(7);
  doc.text("Disclaimer: Prices and availability are subject to change. This brochure is for informational purposes only.", 15, y);

  doc.save("VS_Infra_Plot_Brochure.pdf");
}

function formatIndianRupee(num) {
  if (num >= 10000000) return `Rs. ${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `Rs. ${(num / 100000).toFixed(2)} Lakh`;
  return `Rs. ${num.toLocaleString("en-IN")}`;
}
